/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Onboarding_Crumb_OfflineInputs */

const en_ui_onboarding_crumb_offline = /** @type {(inputs: Ui_Onboarding_Crumb_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Works offline`)
};

const de_ui_onboarding_crumb_offline = /** @type {(inputs: Ui_Onboarding_Crumb_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Läuft offline`)
};

/**
* | output |
* | --- |
* | "Works offline" |
*
* @param {Ui_Onboarding_Crumb_OfflineInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_onboarding_crumb_offline = /** @type {((inputs?: Ui_Onboarding_Crumb_OfflineInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Onboarding_Crumb_OfflineInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_onboarding_crumb_offline(inputs)
	return de_ui_onboarding_crumb_offline(inputs)
});